module.exports = __webpack_public_path__ + "static/media/om_faceshape_long_vector.2d6101d0.svg";